module.exports = __webpack_public_path__ + "img/guaranteed-irish-2021.817f143.png";